<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mx-2"
        small    
        color="info"
        v-on="on"
      >
        Restore
      </v-btn>
    </template>

    <v-card>
      <v-card-text> Are you sure you want to restore <b>{{ payrollCycle.code.toUpperCase() }}</b>? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"          
          class="white--text px-10"      
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      payrollCycle: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.hrisPayrollCycles().restore(this.payrollCycle.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('restored')
              this.$snack({ message: response.data.status })
              this.menu = false
            }
          })
          .catch((err) => {
            if (err.response.status === 500) {              
              this.$snack({ 
                color: 'error',
                message: err.response.data.status, 
              })
            }
          })
          .then(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
